import React, {useState, useEffect, useCallback} from 'react'
import { getFetchUrl, getFetchParams } from '../../helpers'
import { SubPageContainer } from '../App/components/SubPageContainer'
import Draggable from '../../atoms/Draggable/Draggable'
import { Tooltip } from 'react-tooltip'
import { deepCopy } from '../../utilities'
import dayjs from 'dayjs'
import TodoHistory from './TodoHistory'

// Tranlations
import t from '../../translations'

export default function Todo(props) {
    const {checkServerUp, noUser, lang, loginModalOpen} = props

    const [groups, setGroups] = useState()
    const [historyDates, setHistoryDates] = useState([])
    const [dropped, setDropped] = useState(false)
    const [subPage, setSubPage] = useState('')
    const [isHistoryDate, setIsHistoryDate] = useState(null)
    const [currentDataIndexes, setCurrentDataIndexes] = useState([])
    const [isAddingCategory, setIsAddingCategory] = useState(false)
    const [newTextValue, setNewTextValue] = useState('')
    const [isSelectingStatus, setIsSelectingStatus] = useState([-1, -1])

    const getUserTodo = useCallback(async () => {
        const action = 'get'
        const sessionToken = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).sessionToken : ''

        const data = {
            a: action,
            sessionToken,
        }
        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {

                return result.data
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }
    }, [checkServerUp, noUser])

    const refreshData = useCallback(async () => {
        const fetchedData = await getUserTodo()

        await new Promise((resolve, reject) =>{
            setTimeout(() => {
                resolve()
            }, 300)
        })

        setGroups(fetchedData.todos)
        setHistoryDates(fetchedData.historyDates)
    }, [getUserTodo])

    const saveTodoOrder = useCallback(async () => {
        const action = 'saveOrder'
        const sessionToken = JSON.parse(localStorage.getItem('user')).sessionToken

        const data = {
            groups,
            a: action,
            sessionToken,
        }

        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {
                // TODO
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }
        
        setDropped(false)
    }, [groups, checkServerUp, noUser])

    const addTodo = useCallback(async (groupId) => {

        const action = 'new'
        const sessionToken = JSON.parse(localStorage.getItem('user')).sessionToken

        const data = {
            formData: {
                id: groupId,
                text: newTextValue,
            },
            a: action,
            sessionToken,
        }
        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {
                setSubPage('')
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }

        await refreshData()
    }, [newTextValue, refreshData, checkServerUp, noUser])

    const editTodo = useCallback(async (id) => {

        const action = 'edit'
        const sessionToken = JSON.parse(localStorage.getItem('user')).sessionToken

        const data = {
            formData: {
                id,
                text: newTextValue,
            },
            a: action,
            sessionToken,
        }
        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {
                setSubPage('')
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }

        await refreshData()
    }, [newTextValue, refreshData, checkServerUp, noUser])

    const deleteTodo = useCallback(async (id) => {

        const action = 'delete'
        const sessionToken = JSON.parse(localStorage.getItem('user')).sessionToken

        const data = {
            formData: {
                id,
            },
            a: action,
            sessionToken,
        }
        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {
                setSubPage('')
                setCurrentDataIndexes([])
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }

        await refreshData()
    }, [refreshData, checkServerUp, noUser])

    const addCategory = useCallback(async () => {

        const action = 'addCategory'
        const sessionToken = JSON.parse(localStorage.getItem('user')).sessionToken

        const data = {
            formData: {
                text: newTextValue,
            },
            a: action,
            sessionToken,
        }
        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {
                setSubPage('')
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }

        await refreshData()
    }, [newTextValue, refreshData, checkServerUp, noUser])

    const changeStatus = useCallback(async (dataIndexes, id, nextStatus) => {
        setIsSelectingStatus([-1, -1])

        if(nextStatus === 'undo'){
            return
        }
        setGroups((previousState) => {
            const state = deepCopy(previousState)
            state[dataIndexes[0]].items[dataIndexes[1]].status = nextStatus
            state[dataIndexes[0]].items[dataIndexes[1]].updatedAt = dayjs().format('YYYY-MM-DD HH:mm')

            return state
        })

        // Save to backend
        const action = 'saveStatus'
        const sessionToken = JSON.parse(localStorage.getItem('user')).sessionToken

        const data = {
            a: action,
            sessionToken,
            formData: {
                id,
                status: nextStatus,
            }
        }

        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {
                // TODO
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }
    }, [checkServerUp, noUser])

    const toggleGroupCollapseStatus = useCallback(async (groupIndex, expanded) => {
        if(isHistoryDate){
            return
        }

        // Save to backend
        const action = 'toggleGroupExpand'
        const sessionToken = JSON.parse(localStorage.getItem('user')).sessionToken

        setGroups((previousState) => {
            const state = deepCopy(previousState)
            state[groupIndex].status = state[groupIndex].status === 'collapsed' ? 'expanded' : 'collapsed'

            return state
        })

        const id = groups[groupIndex].id
        const data = {
            a: action,
            sessionToken,
            formData: {
                id,
                status: expanded ? 'collapsed' : 'expanded',
            }
        }

        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {
                // TODO
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }
    }, [groups, isHistoryDate, checkServerUp, noUser])

    const getHistoryData = async (date) => {

        const action = 'getHistoryData'
        const sessionToken = JSON.parse(localStorage.getItem('user')).sessionToken

        const dateIsValid = historyDates.some((entry) => dayjs(entry).format('YYYY-MM-DD') === date)

        if(!dateIsValid){
            return
        }

        const data = {
            a: action,
            sessionToken,
            formData: {
                date,
            }
        }

        const serverResponse = await fetch(getFetchUrl('todo'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse?.json()
            if (result?.success) {
                setGroups(result.data)
                setSubPage('')
                setIsHistoryDate(date)
            } else {
                console.log(result?.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }
    }

    useEffect(() => {
        ;(async () => {
            await refreshData()
        })()
        
    },[refreshData])

    useEffect(() => {
        if(dropped){
            ;(async () => {
                await saveTodoOrder()
                await refreshData()
            })()
        }
    },[dropped, saveTodoOrder, refreshData])

    const backToList = <div className='todoSubPageHeader'>
        <Tooltip id='back-to-list'/>
            <box-icon
                type='regular'
                name='arrow-back'
                color='black'
                data-tooltip-id='back-to-list'
                data-tooltip-content={t[lang]['Back to list']}
                data-tooltip-place='left'
                onClick={() => {
                    if(currentDataIndexes.length === 1){
                        setSubPage('manageGroups')
                    }else{
                        setSubPage('')
                    }
                    setCurrentDataIndexes([])
                }}
            />
    </div>

    const currentElement = currentDataIndexes.length ?
        currentDataIndexes[0] === -1 ?
            groups[currentDataIndexes[1]] :

            (currentDataIndexes.length === 2 ?
                groups[currentDataIndexes[0]].items[currentDataIndexes[1]] :
                groups[currentDataIndexes[0]]) :
                    null

    let currentGroups = [{
        dataIndexes: [-1],
        categoryName: t[lang]['Your categories'],
        items: groups?.map((group, groupIndex) => {
            return {
                dataIndexes: group.dataIndexes,
                id: group.id,
                text: group.categoryName,
                status: 'noStatus',
                items: [],
            }
        }) ?? [],
    }]

    return <SubPageContainer {...props}>
        <section className={loginModalOpen ? 'blured' : ''}>
            <h1>{t[lang].specifics_todo['page title']} {subPage !== 'calendar' && isHistoryDate ? `${t[lang]['for']} ${isHistoryDate}` : ''}</h1>
            {subPage !== 'calendar' && isHistoryDate ? <span>{t[lang]['Unchangeable']}</span> : ''}

            <div className='subPageInner'>
                {subPage === 'calendar' && <>
                    {backToList}
                    <TodoHistory
                        {...props}
                        historyDates={historyDates}
                        isHistoryDate={isHistoryDate}
                        getHistoryData={getHistoryData}
                    />
                </>}
                {subPage === '' && <Draggable
                    showCalendar={true}
                    isHistoryDate={isHistoryDate}
                    isSelectingStatus={isSelectingStatus}
                    setIsAddingCategory={() => setIsAddingCategory(false)}
                    groups={groups}
                    setGroups={setGroups}
                    setDropped={setDropped}
                    lang={lang}
                    subPage={subPage}
                    setSubPage={setSubPage}
                    setCurrentDataIndexes={setCurrentDataIndexes}
                    setNewTextValue={setNewTextValue}
                    setIsSelectingStatus={setIsSelectingStatus}
                    changeStatus={changeStatus}
                    toggleGroupCollapseStatus={toggleGroupCollapseStatus}
                />}
                {subPage === 'addItem' && <div>
                    {backToList}
                    {t[lang]['Add item']}
                    
                    <div className='todoTextInputContainer'>
                        <div>
                            {t[lang]['New item']}
                        </div>
                        <div>
                            <input
                                autoFocus
                                type='text'
                                value={newTextValue}
                                onChange={(event) => setNewTextValue(event.target.value)}
                                onKeyUp={(event) => {
                                    if(event.key === 'Enter'){
                                        isAddingCategory ? addCategory() : addTodo(Number(currentElement.id))
                                    }
                                }}
                            />
                        </div>
                        <div>
                            <button
                                onClick={() => {isAddingCategory ? addCategory() : addTodo(Number(currentElement.id))}}
                            >
                                {t[lang]['Submit']}
                            </button>
                        </div>
                    </div>
                </div>}
                {subPage === 'editItem' && <div>
                    {backToList}
                    {t[lang]['Edit item']}

                    <div className='todoTextInputContainer'>
                        <div>
                            {t[lang]['New title']}
                        </div>
                        <div>
                            <input
                                autoFocus
                                type='text'
                                value={newTextValue}
                                onChange={(event) => setNewTextValue(event.target.value)}
                                onKeyUp={(event) => {
                                    if(event.key === 'Enter'){
                                        editTodo(Number(currentElement.id))
                                    }
                                }}
                            />
                        </div>
                        <div>
                            <button
                                onClick={() => editTodo(Number(currentElement.id))}
                            >
                                {t[lang]['Submit']}
                            </button>
                        </div>
                        
                    </div>
                </div>}
                {subPage === 'deleteItem' && <div>
                    {backToList}
                    {currentDataIndexes.length === 2 ? t[lang]['Delete item'] : t[lang]['Delete category']}

                    <div className='todoTextConfirmContainer'>
                        {currentElement.items.length > 0 && <div>
                            {t[lang]['Item count 1']} <b>{currentElement.items.length}</b> {t[lang]['Item count 2']} 
                        </div>}
                        <div>
                            {t[lang]['Are you sure?']}
                        </div>
                        
                        <div>
                            <button
                                onClick={() => deleteTodo(Number(currentElement.id))}
                            >
                                {t[lang]['Yes']}
                            </button>
                        </div>
                    </div>
                </div>}
                {subPage === 'manageGroups' && <div>
                    {backToList}
                    {t[lang]['Manage categories']}

                    <Draggable
                        isEditingGroups
                        setIsAddingCategory={() => setIsAddingCategory(true)}
                        groups={currentGroups}
                        setGroups={setGroups}
                        setDropped={setDropped}
                        lang={lang}
                        subPage={subPage}
                        setSubPage={setSubPage}
                        setCurrentDataIndexes={setCurrentDataIndexes}
                        setNewTextValue={setNewTextValue}
                    />

                </div>}
            </div>
        </section >
    </SubPageContainer>
        
}